module.exports = __webpack_public_path__ + "rainbow.2dcec13a.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/rainbow.svg
// module id = +ZNn
// module chunks = 0